module.exports = JSON.parse('{"Copied":"Test Copied","Failed to copy":"Test Failed to copy"}')